export const GET_TOTAL_STATS = 'HC/get_total_stats';
export const GET_GRAPH_STATS = 'HC/get_graph_stats';
